import React, { useContext, useEffect } from 'react';
import * as S from '../styles';
import TeamSection from '../components/TeamsSection';
import { HeaderContext } from '~/context';
import { Icon } from '~/components';
import { propTypes, defaultProps } from './propsValidation';
import downloadFile from '~/utils/downloadFile';

export default function MatchSheetMobile({ publicFiles, ...props }) {
  const { setButtonRight, setHeaderProps, headerProps } = useContext(
    HeaderContext
  );
  useEffect(() => {
    if (!Object.keys(headerProps).length) {
      setButtonRight(
        <Icon
          name="download"
          color={
            Object.keys(publicFiles.data).length === 0 ||
            !publicFiles.data.hojaPartido
              ? 'light2Opacity'
              : 'white'
          }
          onClick={() => {
            if (publicFiles.data.hojaPartido)
              downloadFile(publicFiles.data.hojaPartido.id);
          }}
        />
      );
    }
  }, [setButtonRight, headerProps, publicFiles]);
  useEffect(() => {
    return () => {
      setHeaderProps({});
    };
  }, [setHeaderProps]);
  return (
    <S.ContainerSm>
      <TeamSection tabMode {...props} />
    </S.ContainerSm>
  );
}

MatchSheetMobile.propTypes = propTypes;

MatchSheetMobile.defaultProps = defaultProps;
